'use strict';
import Auth from '../../../components/auth/auth.service';

export default function GroupService($http, $cookies, $state) {
  'ngInject';

  let Group = {
    changeStatus(id, status) {
      return $http.post('/api/users/status', {userId: id, status: status})
        .then(response => {
          console.log('Status Changed Successfully')
          return response.data;
        })
        .catch(err => {
          console.log('Either the groupAdmin is not registered with the group or groupAdmin does not exist');
          return;
        });
    },
    getGroupDetails(id) {
      return $http.get('/api/groups/getGroup/' + id)
        .then((response) => {
          return response.data;
        })
        .catch(err => {
          console.log('The group data fetch unsuccessful');
          return;
        })
    },
    getPhysicians(user) {
      //For SafeStart Admin Role admin
      if(user.role == 'safestartadmin') {
        return $http.post('/api/users/physicians', user)
        .then(response => {
          console.log('The physicians fetched successfully')
          return response.data;
        })
        .catch(err => {
          $state.go('logout');          //Directly logout if there is an error
          console.log('Either the groupAdmin is not registered with the group or groupAdmin does not exist');
          return;
        });
      }
      //Else for other admins
      else {
        return $http.get('/api/users/staffMembers')
        .then(response => {
          console.log('The physicians fetched successfully')
          return response.data;
        })
        .catch(err => {
          $state.go('logout');          //Directly logout if there is an error
          console.log('Either the groupAdmin is not registered with the group or groupAdmin does not exist');
          return;
        });
      }
    },
    setPriviledges(data) {
      console.log(data)
      return $http.put('/api/users/editInformation/' + data._id, {
        role: data.role
      })
        .then((response) => {
          console.log('The user has been updated successfully');
          return response.data;
        })
        .catch(err => {
          console.log('Cannot update the user');
          return;
        })
    },
    editPhysicians(data) {
      console.log(data)
      return $http.put('/api/users/editInformation/' + data._id, {
        firstName: data.firstName,
        lastName: data.lastName,
        staffRole: data.staffRole
      })
        .then((response) => {
          console.log('The user has been updated successfully');
          return response.data;
        })
        .catch(err => {
          console.log('Cannot update the user');
          return;
        })
    },
    deletePhysicians(data) {
      return $http.delete('/api/users/' + data)
        .then((response)=> {
          response.data;
          return;
        })
        .catch(err => {
          console.log('Cannot delete the physician,either it does not exists or not registered');
          return;
        })
    },
    renameGroup(data) {
      return $http.put('/api/groups/' + data._id, {
        name: data.name
      })
        .then((response) => {
          console.log('The group has been renamed successfully');
          return response.data;
        })
        .catch(err => {
          $state.go('logout');                //Directy logout for this error
          console.log('Cannot rename the group');
          return;
        })
    },
    invitePhysician(data) {
      console.log(data);
      return $http.post('/api/users/inviteStaffMember', data)
        .then((response) => {
          console.log('The staff member has been created successfully');
          return response.data;
        })
        .catch(err => {
          console.log(err);     //view the error here
          console.log('Cannot create the staff member');
          throw err;
        })
    },
    getTimeoutData(user) {
      return $http.post('/api/schedules/schedulesData', user)
        .then((response) => {
          console.log('The schedule response fetched successfully');
          return response.data;
        })
        .catch(err => {
          console.log(err)    //view the err here
          console.log('Cannot fetch the schedules');
        })
    },
    getChecklistData(user) {
      return $http.post('/api/checklists/getChecklist', user)
        .then((response) => {
          console.log('The checklist response fetched succeessfully');
          return response.data;
        })
    },
    sendPdf(checklistArray, dateArray , user) {
      return $http.post('/api/checklists/pdf', {checklistArray, dateArray, user})
      .then((response) => {
        console.log('The pdf has been sent to the email user.email');
        return response.data;
      })
    },
    analytics(user, model, timeFrom, timeTo) {
      if(timeFrom && timeFrom.opened == false) {
        timeFrom = null
      }
      if(timeTo && timeTo.opened == false) {
        timeTo = null
      }
      return $http.post('/api/analytics', {user, model, timeFrom, timeTo})
        .then((response) => {
          console.log('Analytics data fetched successfully');
          return response.data;
        })
        .catch(error => {
          console.log(error);
        })
    },
    addQuestion(data) {
       $http.post('api/groupQuestions', {name: data.name, group: data.group})
        return   $http.get('api/groupQuestions/' + data.group + '/all')
          .then((res) => {
          console.log('Question create successfully');
          return res;
          })
        .catch(err => {
          console.log(err);     //view the error here
          console.log('question not saved');
          throw err;
        })
    },
    getQuestion(id) {
      return $http.get('api/groupQuestions/'+ id +'/all')
        .then((response) => {
          console.log('Question data fetched successfully');
          return response;
        })
        .catch(err => {
          console.log(err);     //view the error here
          console.log('Question data not fetched');
          throw err;
        })
    },

     deleteQuestions(data) {
      return $http.delete('/api/groupQuestions/' + data)
        .then((response)=> {
          response.data;
          return;
        })
        .catch(err => {
          console.log('Cannot delete the Question,either it does not exists or not registered');
          return;
        })
    }

  }
  return Group;
}




// WEBPACK FOOTER //
// ./client/app/admin/groupAdmin/groupAdmin.service.js